<template>
  <svg
    width="261"
    height="127"
    viewBox="0 0 261 127"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M223.66 36.1607L229.624 29.3649L242.723 40.9857L243.985 39.5479C250.934 31.6316 251.077 20.0404 244.877 11.9887L245.626 11.1387C247.136 9.41759 246.976 6.78726 245.26 5.26911L243.43 3.64525C241.718 2.1271 239.101 2.28779 237.591 4.01315L236.843 4.86315C228.127 -0.321391 216.702 1.26442 209.753 9.18077L208.491 10.6186L221.59 22.2394L215.575 29.0901C192.734 10.7793 163.003 0 130.496 0C97.9886 0 68.939 10.5425 46.1949 28.4769L40.5878 22.0871L53.7412 10.4198L52.4793 8.98202C45.5345 1.06989 34.1225 -0.520145 25.4068 4.6517L24.8473 4.01315C23.3372 2.29202 20.7208 2.1271 19.0088 3.64525L17.179 5.26911C15.467 6.78726 15.303 9.41759 16.8131 11.1387L17.3683 11.773C11.1554 19.8247 11.2984 31.4244 18.2517 39.345L19.5136 40.7828L32.5535 29.2127L38.0513 35.4756C14.5374 57.5289 0 88.3486 0 123.549C0 124.704 0.0168257 125.854 0.0504771 127H15.7741C15.7404 125.854 15.7152 124.704 15.7152 123.549C15.7152 61.4786 67.105 15.3845 130.5 15.3845C193.895 15.3845 245.285 61.4744 245.285 123.549C245.285 124.704 245.26 125.854 245.226 127H260.95C260.979 125.854 261 124.704 261 123.549C261 88.7122 246.757 58.1675 223.668 36.1649L223.66 36.1607Z"
      fill="url(#paint0_linear_16083_185)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_16083_185"
        x1="130.5"
        y1="41"
        x2="130.5"
        y2="118.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#5061FA" />
        <stop
          offset="1"
          stop-color="#5061FA"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
